"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hubSelector = void 0;
/* eslint-disable indent */
var hubSelector = (oldSelector, newSelector) => function () {
  if (typeof (arguments.length <= 0 ? undefined : arguments[0]) !== 'object') {
    return oldSelector(...arguments);
  }
  return newSelector(...arguments);
};
/* eslint-enable indent */
exports.hubSelector = hubSelector;